import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "navigation" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ico ico-effect" }),
      /*#__PURE__*/_createElementVNode("h4", null, "用途")
    ]),
    /*#__PURE__*/_createElementVNode("ul", { class: "item-list list-inline" }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/aiqingxianhua/" }, "爱情鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/youqingxianhua/" }, "友情鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "/shengriliwu/",
          target: "_blank"
        }, "生日鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/songzhangbeixianhua/" }, "问候长辈")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/songlaoshixianhua/" }, "回报老师")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/tanbingweiwenxianhua/" }, "探病慰问")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/daoqianxianhua/" }, "道歉鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/hunqingxianhua/" }, "婚庆鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/zhufuqinghexianhua/" }, "祝贺鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/aisixianhua/" }, "哀思鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/businessFlower/" }, "商务鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/businessFlower/kaiyehualan/" }, "开业花篮")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/florist/" }, "自选鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/worldflora/" }, "港澳台送花")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ico ico-texture" }),
      /*#__PURE__*/_createElementVNode("h4", null, "用途")
    ]),
    /*#__PURE__*/_createElementVNode("ul", { class: "item-list list-inline" }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/aiqingxianhua/" }, "爱情鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/youqingxianhua/" }, "友情鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "/shengriliwu/",
          target: "_blank"
        }, "生日鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/songzhangbeixianhua/" }, "问候长辈")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/songlaoshixianhua/" }, "回报老师")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/tanbingweiwenxianhua/" }, "探病慰问")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/daoqianxianhua/" }, "道歉鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/hunqingxianhua/" }, "婚庆鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/zhufuqinghexianhua/" }, "祝贺鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/aisixianhua/" }, "哀思鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/businessFlower/" }, "商务鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/businessFlower/kaiyehualan/" }, "开业花篮")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/florist/" }, "自选鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/worldflora/" }, "港澳台送花")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ico ico-color" }),
      /*#__PURE__*/_createElementVNode("h4", null, "用途")
    ]),
    /*#__PURE__*/_createElementVNode("ul", { class: "item-list list-inline" }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/aiqingxianhua/" }, "爱情鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/youqingxianhua/" }, "友情鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "/shengriliwu/",
          target: "_blank"
        }, "生日鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/songzhangbeixianhua/" }, "问候长辈")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/songlaoshixianhua/" }, "回报老师")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/tanbingweiwenxianhua/" }, "探病慰问")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/daoqianxianhua/" }, "道歉鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/hunqingxianhua/" }, "婚庆鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/zhufuqinghexianhua/" }, "祝贺鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/aisixianhua/" }, "哀思鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/businessFlower/" }, "商务鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/businessFlower/kaiyehualan/" }, "开业花篮")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/florist/" }, "自选鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/worldflora/" }, "港澳台送花")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ico ico-sort" }),
      /*#__PURE__*/_createElementVNode("h4", null, "用途")
    ]),
    /*#__PURE__*/_createElementVNode("ul", { class: "item-list list-inline" }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/aiqingxianhua/" }, "爱情鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/youqingxianhua/" }, "友情鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "/shengriliwu/",
          target: "_blank"
        }, "生日鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/songzhangbeixianhua/" }, "问候长辈")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/songlaoshixianhua/" }, "回报老师")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/tanbingweiwenxianhua/" }, "探病慰问")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/daoqianxianhua/" }, "道歉鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/hunqingxianhua/" }, "婚庆鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/zhufuqinghexianhua/" }, "祝贺鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/aisixianhua/" }, "哀思鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/businessFlower/" }, "商务鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/businessFlower/kaiyehualan/" }, "开业花篮")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/florist/" }, "自选鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/worldflora/" }, "港澳台送花")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ico ico-price" }),
      /*#__PURE__*/_createElementVNode("h4", null, "用途")
    ]),
    /*#__PURE__*/_createElementVNode("ul", { class: "item-list list-inline" }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/aiqingxianhua/" }, "爱情鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/youqingxianhua/" }, "友情鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "/shengriliwu/",
          target: "_blank"
        }, "生日鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/songzhangbeixianhua/" }, "问候长辈")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/songlaoshixianhua/" }, "回报老师")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/tanbingweiwenxianhua/" }, "探病慰问")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/daoqianxianhua/" }, "道歉鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/hunqingxianhua/" }, "婚庆鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/zhufuqinghexianhua/" }, "祝贺鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/aisixianhua/" }, "哀思鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/businessFlower/" }, "商务鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/businessFlower/kaiyehualan/" }, "开业花篮")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/florist/" }, "自选鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/worldflora/" }, "港澳台送花")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ico ico-num" }),
      /*#__PURE__*/_createElementVNode("h4", null, "用途")
    ]),
    /*#__PURE__*/_createElementVNode("ul", { class: "item-list list-inline" }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/aiqingxianhua/" }, "爱情鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/youqingxianhua/" }, "友情鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "/shengriliwu/",
          target: "_blank"
        }, "生日鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/songzhangbeixianhua/" }, "问候长辈")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/songlaoshixianhua/" }, "回报老师")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/tanbingweiwenxianhua/" }, "探病慰问")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/daoqianxianhua/" }, "道歉鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/hunqingxianhua/" }, "婚庆鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/zhufuqinghexianhua/" }, "祝贺鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/aisixianhua/" }, "哀思鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/businessFlower/" }, "商务鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/businessFlower/kaiyehualan/" }, "开业花篮")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/florist/" }, "自选鲜花")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "/worldflora/" }, "港澳台送花")
      ])
    ])
  ])
], -1)
const _hoisted_3 = { class: "grid-wrapper" }
const _hoisted_4 = { class: "grid-panel" }
const _hoisted_5 = { class: "img-box" }
const _hoisted_6 = { class: "info-cont" }
const _hoisted_7 = { class: "price" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "price-sign" }, "¥", -1)
const _hoisted_9 = { class: "price-num" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "product-title" }

import { getFlowers } from '../http/index'
import { ref, onMounted } from 'vue'

import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'FlowerList',
  props: {
  image: String,
  type: Number,
},
  setup(__props) {

const props = __props;

const router = useRouter();

const list = ref();
onMounted(async () => {
  let parms = {
    Id: 0,
    Type: props.type
  }
  list.value = (await getFlowers(parms)).data.result
})
const GoToDetail = (currId: Number) => {
  const sss = ref()
  sss.value = currId;
  router.push({ path: '/detail', query: { id: sss.value, type: props.type } });
}

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb, { separator: "/" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                  default: _withCtx(() => [
                    _createTextVNode("首页")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_breadcrumb_item, null, {
                  default: _withCtx(() => [
                    _createTextVNode("列表页")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_aside, { width: "200px" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  style: {"display":"inherit","width":"1048px","margin-top":"-20px"},
                  src: __props.image
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "grid-item",
                      key: item
                    }, [
                      _createVNode(_component_el_link, {
                        onClick: ($event: any) => (GoToDetail(item.id))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_el_image, {
                                class: "list-image",
                                src: item.image
                              }, null, 8, ["src"])
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, [
                                _hoisted_8,
                                _createElementVNode("span", _hoisted_9, _toDisplayString(item.price), 1)
                              ]),
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", _hoisted_11, _toDisplayString(item.title), 1)
                              ])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})